module.exports = __webpack_public_path__ + "img/iconEmailGreen.b954a036.svg";